import React, { useState, createRef, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { login, subadminLogout, subadminOrgLogout  } from "../../../context/actions/user";
import { getFileDoc, getUnlabeledFileDoc, appendDocumentsById, getDocumentPage, findDocumentsById } from "../../../context/actions/document";

import { toasterConfig } from "../../../utils/constants";
import { SocketContext } from "../../../context/actions/socket";
import LoaderUI from "../../common/loader";

toast.configure();
const SubadminLogin = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loginData, setLoginData] = useState(JSON.parse(queryParams.get("data")))
  const history = useHistory();
  useEffect(() => {
    console.log(loginData, "loginData")
    if (loginData) {
      console.log('loginData -->', loginData)
      // return;
      dispatch(
        subadminOrgLogout(loginData, (res) => {
            setTimeout(() => {
              console.log('Callback completed');
            localStorage.setItem("TOKEN", JSON.stringify(loginData?.token));
            localStorage.setItem("LOGOUT", false);
            toast.success("Login Successful", toasterConfig);
            dispatch({ type: "LOGIN", data: loginData });
         
            if(loginData?.queueId){

              // history.push('/uploading-file', { queueId: loginData?.queueId,docId: loginData?.docId})
              //  console.log('sjadkhjkhaskjdhsajdhsjkahdkjahs')
              dispatch(
                getDocumentPage({docId : loginData?.docId, queueId: loginData?.queueId}, (res) => {
                  console.log('res of getDocPage -->', res)
                  history.push('/uploading-file', { queueId: loginData?.queueId,docId: loginData?.docId, pageNumber: res.pageNumber})
                })
              )
              // history.push('/uploading-file', { queueId: loginData?.queueId,docId: loginData?.docId})
            }
            else if (loginData?.docId) {
              if (loginData?.labeled) {

              // dispatch({ type: "SET_SELECTED_FILE", selectedFileId: loginData?.docId.toString() });
              // window.location.href = '/documentDetail';
                dispatch(
                  getFileDoc({ docId: loginData?.docId.toString() }, (result) => {
                    console.log('result sdsdsdsd 1 ', result)
                    if (result) {
                      if (Object.keys(result).length) {
                        let params = {
                          folder: result?.folder?.id,
                          deleted: false,
                          page: 1,
                          limit: 10,
                          reviewRequested: false,
                          otherDocuments: false,
                          type: '',
                          assignedTo: null,
                          fromAdmin: true
                        }
                        result.folder = result?.folder?._id
                        // dispatch({ type: "REDIRECT", data: [result] });
                        dispatch({ type: "SET_FOLDER_ID", data : result.folder})
                        dispatch(appendDocumentsById(params, (result)=>{
                          if(result) {
                            dispatch({type:"APPEND_DOCUMENT_LIST_SUBADMIN",  data: result.docs})
                           dispatch({type:"TOTAL_RECORDS",  data: result.totalDocs})
                            history.push("/documentDetail",{ page: params.page, hasNextPage: result?.totalDocs > 10 ? true : false})
                          }
                        }))
                        // setTimeout(() => {
                        //   console.log('window open before')
                        //   window.location.href = '/documentDetail';
                        // }, 100);
                      }
                      else { //else condition is used to check if response is present or not. This condititon comes to play is the file is archived. 
                        window.open(`/documents`, "_blank");
                        toast.success("The file is already archived", toasterConfig);
                      }
                    }
                  })
                )

              } else {


                dispatch(
                  getUnlabeledFileDoc({ docId: loginData?.docId.toString(), Au: null, pageNumber: 1 }, (result) => {
                    console.log('resultresult', result)
                    if (result) {
                      dispatch({ type: "DOCUMENT_DETAIL", data: result })
                      let params = {
                        "folder": result.folder._id,
                        "deleted": false,
                        "page": 1,
                        "limit": 9,
                        "docId": loginData?.docId.toString(),
                        "otherDocuments": true,
                        "assignedTo":null,
                        "selectedDocument": result,
                        fromAdmin: true
                      }
                      if(result.complete == true || result.reviewLabeled == true){
                        params = {...params, complete: true, reviewLabeled: true}
                      }
                      // dispatch({ type: "REDIRECT", data: [result] });
                      dispatch(findDocumentsById(params, (response)=>{
                        if(response){
                          let docs = [];
                          let totalDocs = response?.totalDocs;
                          if (params?.selectedDocument) {
                            docs = [params.selectedDocument, ...response.docs];
                            totalDocs = totalDocs + 1;
                          } else {
                            docs = response.docs;
                          }
                          dispatch({ type: "LIST_DOCUMENT", data: docs, totalDocRecords: totalDocs, folder: params?.folder });
                          // dispatch({type:"LIST_DOCUMENT_SUBADMIN",  data: response, folder: params?.folder })
                          history.push("/dennis", {title : 'Unlabled Document', documentExclude : result?._id, type : result?.type_info?._id, hasPrevPage: response?.hasPrevPage, hasNextPage: response?.hasNextPage, page: params.page });
                        }
                      }))
                      // history.push("/dennis", { title: 'Unlabled Document', documentExclude: result?._id, type: result?.type_info?._id });
                    }

                  })
                );
                //  history.push("/dennis");
              }

            } else if (loginData?.irsIncomeId) {
              history.push('/income_analyzer', { irsIncomeId: loginData?.irsIncomeId, allowComplete: true })
            } else if ( loginData?.analyzerId){
               
              history.push('/wise', { analyzerId: loginData?.analyzerId, allowComplete: true })

            }
            else {
              history.push("/dashboard");
            }
            }, 1000);
          

        })
      );
    } else {
      history.push("/login");
    }

    // // Remove query parameters from the URL
    // const newUrl = window.location.pathname;
    // window.history.replaceState({}, "", newUrl);
  }, [loginData]);

  return (
    <div className={`login-blc m-auto signup-box`}>
      <LoaderUI />
    </div>
  );
};

export default SubadminLogin;
